import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse} from '../interfaces/home';

@Injectable({
  providedIn: 'root'
})
export class RequiredServiceDocumentService {
  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl+'RequiredServiceDocument/';
  // fetch all RequiredServiceDocument in the database
  allRequiredServiceDocument(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getRequiredServiceDocument(id: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
  getRequiredServiceDocumentByName(name: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl + 'name/' + name);
  }
  postRequiredServiceDocument(data: any){
    return this.http.post(this.baseUrl, data);
  }
  deleteRequiredServiceDocument(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateRequiredServiceDocument(id: any, data: any){
    return this.http.put(this.baseUrl +id, data);
  }
}
